import { render, staticRenderFns } from "./Loanables.vue?vue&type=template&id=1792ecf3"
import script from "./Loanables.vue?vue&type=script&lang=js"
export * from "./Loanables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports